<!-- <!DOCTYPE html>
<html lang="en"> -->

<!-- <head> -->
<title>Inicio de sesion</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
<!--===============================================================================================-->
<!-- <link href="./assets/login/images/favicon.png" rel="icon"> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/vendor/bootstrap/css/bootstrap.min.css" /> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/css/icons.css" /> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/css/main.css" /> -->
<!--===============================================================================================-->
<!-- </head> -->

<!-- <body style="background-color: #999999;"> -->

<div class="limiter fadeInDown">
    <div class="container-login100">
        <div class="login100-more" style="background-image: url(&#39;./assets/login/images/bg-01.jpg&#39;);"></div>

        <div class="wrap-login100 p-l-50 p-r-50 p-t-72 p-b-50 m-login__wrapper">
            <div class="m-login__logo">
                <a href="#"><img src="./assets/login/images/logotipo.png" /></a>
            </div>

            <form [formGroup]="changeForm" (ngSubmit)="onSubmit()" class="login100-form validate-form" autocomplete="off" validate="off">
                <span class="login100-form-title p-b-59">Cambiar contraseña</span>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <div class="input-group-addon"><i class="icon-key"></i></div>
                    <input type="password" id="contrasena1" class="form-control" formControlName="contrasena1" name="contrasena1" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Digite su nueva contraseña">
                </div>
                <div class="col-md-12 col-sm-12 form-group input-group">
                    <p *ngIf="changeForm.get('contrasena1').hasError('minlength') && changeForm.get('contrasena1').dirty" class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;La contraseña es demasiado corta</p>
                    <p *ngIf="changeForm.get('contrasena1').hasError('notnumber') && changeForm.get('contrasena1').dirty" class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Su contraseña debe contener al menos un caracter numerico</p>
                    <p *ngIf="changeForm.get('contrasena1').hasError('mayuscula') && changeForm.get('contrasena1').dirty" class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Su contraseña debe contener al menos una letra mayuscula</p>
                    <p *ngIf="changeForm.get('contrasena1').hasError('minuscula') && changeForm.get('contrasena1').dirty" class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Su contraseña debe contener al menos una letra minuscula</p>
                    <p *ngIf="changeForm.get('contrasena1').hasError('especial') && changeForm.get('contrasena1').dirty" class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Su contraseña debe contener almenos un caracter especial</p>
                </div>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <div class="input-group-addon"><i class="icon-key"></i></div>
                    <input type="password" id="contrasena2" class="form-control" formControlName="contrasena2" name="contrasena2" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Repetir contraseña">
                </div>
                <div class="col-md-12 col-sm-12 form-group input-group">
                    <p *ngIf="changeForm.get('contrasena2').hasError('equalsTo') && changeForm.get('contrasena2').dirty" class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Las contraseñas no coinciden</p>
                </div>
                <div class="col-md-12 col-sm-12 mt-10">
                    <input type="submit" [disabled]="!changeForm.valid" class="boton_personalizado" value="Cambiar contraseña">
                </div>

            </form>
            <div class="col m--align-left copyright">
                ©2018 Willis Towers Watson. Todos los Derechos Reservados.
            </div>
        </div>
    </div>
</div>


<script src="./assets/login/vendor/jquery/jquery-3.2.1.min.js"></script>
<!--===============================================================================================-->

<script src="./assets/login/vendor/bootstrap/js/popper.js"></script>
<script src="./assets/login/vendor/bootstrap/js/bootstrap.min.js"></script>
<!--===============================================================================================-->
<script src="./assets/login/js/main.js"></script>
<script src="https://www.google.com/recaptcha/api.js?render=6LeDDyYqAAAAAJQHoSdZI8BRXax9ye84bh9xKGrd"></script>